import TransactionInterface from "@homegame/common/dist/interface/transaction.interface";
import TransactionStatus from "@homegame/common/dist/enum/transaction-status.enum";
import TransactionType from "@homegame/common/dist/enum/transaction-type.enum";

export default function computeDebtToTable(
  transactions: TransactionInterface[],
  currentPlayerId: number,
  cashoutChips: number,
  gameRate: number,
): number {
  let totalBuyInMoney = 0;
  let totalBuyInChips = 0;

  for (const { type, fromUserId, chips, amount, status } of transactions) {
    if (status !== TransactionStatus.APPROVED) continue;

    if (type === TransactionType.BUY_IN && fromUserId === currentPlayerId) {
      totalBuyInChips += chips;
      totalBuyInMoney += amount;
    }
  }

  const amountWonLost = (cashoutChips - totalBuyInChips) * gameRate;
  return totalBuyInMoney + amountWonLost;
}
